<template>  
  <div class="container">
    <ProdutosCadastrados />
  </div>
</template>
<script>
import ProdutosCadastrados from './shared/estoque/ProdutosCadastrados.vue'
export default {
  components: {
    ProdutosCadastrados
  },
  created: function () {
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// Estoque.vue?01470782